// Exported methods to connect the BIMSearch UI to the engine and viewer

import { BimSearch } from "./BimSearch";
import { BimsearchViewer } from "./BimsearchViewer";
import {
    logCreateSchedule, logSelectCategory,


    logTableLineSelected, logTemplate
} from "./IAmecLog";
import { DataForMenus } from "./ResultClasses";
import { Collection } from "./TemplatesAndCollections";

// Method to be called when the model first open
// paramters:
// itemStruct - model item (vertion or item) - struct recieved from getNextLevel
// returnMethod - method called when the model is done loading will pass 2 paramters, DataForMenus object, and header for the left menu
// no longer used, doubleClickMethod - method that will be called whenever a user double click of element and should change the left menu selection, pass DataForMenus as parameter
// divElement - ui div element for autodesk viewer
// leafText - opened element name recieved from getNextLevel, only used for adding version to header
export async function loadModel(
    itemStruct,
    returnMethod,
    divElement,
    leafText = null
) {
    //var leafId = itemStruct.idToOpen;
    console.log("Load Model");
    console.log(itemStruct);

    if (itemStruct == true) {
        itemStruct = {};
        itemStruct.id = "https://developer.api.autodesk.com/data/v1/projects/b.3139d2cd-5f07-46f0-8e27-89ca76d677be/items/urn:adsk.wipprod:dm.lineage:WOlPZrkuT_2vipWslB1eyw";
        itemStruct.idToOpen = "dXJuOmFkc2sud2lwcHJvZDpmcy5maWxlOnZmLldPbFBacmt1VF8ydmlwV3NsQjFleXc_dmVyc2lvbj00";
        itemStruct.text = "Office Building_english.rvt";
    }

    // use the return method to return empty data in order to clear the previous model
    var tempData = new DataForMenus();
    // returnMethod(tempData, "");

    bimSearch = new BimSearch();

    bimSeachViewer = new BimsearchViewer(
        itemStruct,
        divElement,
        bimSearch,
        returnMethod,
        leafText
    );
}

// Register the method that gets called when selection changed
// onSelectionChangeCallback - method called whenever the selection is changed, should effect the quick count widget, pass array of QuickDataField as paramter
export async function registerSelectionChangeMethod(callback) {
    bimSeachViewer.onSelectionChangeCallback = callback;
}

// Unregister the method that gets called when selection changed
export async function unRegisterSelectionChangeMethod() {
    bimSeachViewer.onSelectionChangeCallback = null;
}

// Called when the user press the select categories button
// pass array of the selected categories
// return DataForMenus that should change the left menu
export async function updateCategory(categories, returnMethod) {
    var res = await bimSearch.selectCategory(categories, null);

    bimSeachViewer.isolateElements(bimSearch.categoryElements);

    logSelectCategory(bimSearch);

    return res;
}

// called when the user change the parameter that the 2nd filter is done by
// recieves the parameter we want to filter by
// return DataForMenus that should change the left menu
export async function updateFilterBy(filter) {
    return await bimSearch.changeFilterBy(filter);
}

// called when the user apply the second filter value selection
// recieves an array of the selected values
// return DataForMenus that should change the left menu
export async function applySecondFilter(values) {
    var res = await bimSearch.selectSecondFilterValues(values);
    bimSeachViewer.isolateElements(bimSearch.filteredElements);
    return res;
}

// called when the user apply the second filter using the operator option
// operator - chosen operator operatorValues enum
// return DataForMenus that should change the left menu
export async function applySecondFilterWithOperator(operator, value) {
    var res = await bimSearch.selectSecondFilterValueWithOperator(
        operator,
        value
    );
    bimSeachViewer.isolateElements(bimSearch.filteredElements);
    return res;
}

// called when the user change the line selection in the table
// elements - an array of the coombined elements from all selected lines
export async function tableSelect(elements) {
    bimSeachViewer.selectElements(elements);
    logTableLineSelected();
}

// used to isolate the table on 0 lines collection
export async function isolateElements(elements) {
    bimSeachViewer.isolateElements(elements);
}

// called when the user selectes a template
// templateName - chosen template
// return DataForMenus that should change the left menu
// normally getSchedule should be called immidiately after to recieve the table
export async function chooseTemplate(templateName, templateFolder = "Default") {
    var res = await bimSearch.selectTemplate(templateName, templateFolder);

    bimSeachViewer.isolateElements(bimSearch.filteredElements);

    logSelectCategory(bimSearch);
    logTemplate(templateName);

    return res;
}

// Gets the data for the table
// properties - selected properties
// groupingParameters - selected grouping paramters
// return DataForTable object
export async function getSchedule(properties, groupingParameters) {
    logCreateSchedule(bimSearch, properties, groupingParameters);

    return await bimSearch.createSchedule(properties, groupingParameters);
}

// Should be called whenever the viewer div element changes size
export function resizeViewer() {
    if (bimSeachViewer && bimSeachViewer.viewer) bimSeachViewer.viewer.resize();
}

// return a dictonary object
// category name --> [] of QuickDataField
export function getDetailedSelectionInfo() {
    return bimSeachViewer.getFullSelectionData();
}

// Get current view screenshot
export async function viewerGetScreenShot(width, height, callback) {
    if (bimSeachViewer.viewer) {
        bimSeachViewer.viewer.getScreenShot(width, height, callback);
    }
}

// return QuickInfo
export async function getTemplateQuickInfo(templateName, TemplateFolder) {
    return await bimSearch.getTemplateInfo(templateName, TemplateFolder);
}

// Craete new template folder
// returns templates folders // Dictionary<string, string> (after the change)
// throw "Folder already exist"
export function addTemplateFolder(folderName) {
    return bimSearch.addTemplateFolder(folderName);
}

// Delete a template folder
// returns templates folders // Dictionary<string, string> (after the change)
// throw "Folder doesn't exist"
export function deleteTemplateFolder(folderName) {
    return bimSearch.deleteTemplateFolder(folderName);
}

// rename a template folder
// returns templates folders // Dictionary<string, string> (after the change)
// throw "Folder already exist"
// throw "Folder doesn't exist"
export function renameTemplateFolder(originalName, newName) {
    return bimSearch.renameTemplateFolder(originalName, newName);
}

//Save a new BIMSearch template
// Parameters:
//      templateFolder - string
//      title - template namne - string
//      description - string
//      properties - selected properties [] of string
//      groupBy - selected grouping optrions - [] of string
//      searchValue - current table search value - string
// returns-
//      templates folders // Dictionary<string, string> (after the change)
// Comment-
//      If template already exist resave it - responsibility to confirm with the user outside this function
export function saveTemplate(templateFolder, title, description, properties, groupBy, searchValue) {
    return bimSearch.saveTemplate(templateFolder, title, description, properties, groupBy, searchValue);
}

// deletes a new BIMSearch template
// Parameters:
//      templateFolder - string
//      title - template namne - string
// returns-
//      templates folders // Dictionary<string, string> (after the change)
// throws-
//      "can't find template"
export function deleteTemplate(templateFolder, title) {
    return bimSearch.deleteTemplate(templateFolder, title);
}

// Edit a new BIMSearch template
// throws-
//      "can't find template"
//      "new name already taken"
// returns-
//      templates folders // Dictionary<string, string> (after the change)
export function editTemplate(ogrinalTemplateFolder, originalTitle, newTemplateFolder, newTitle, newDescription) {
    return bimSearch.editTemplate(ogrinalTemplateFolder, originalTitle, newTemplateFolder, newTitle, newDescription);
}

// create a new collection, doesn't save it on DB
// return collection
// parameters:
//  elements, elements of selected lines, same a passed to tableSelect
export async function createCollection(elements, properties, groupedBy) {
    var collection = new Collection(properties, groupedBy);
    await bimSearch.addElementsToCollection(collection, elements);
    return collection;
}

// return DataForTable
export async function getCollectionTable(collection) {
    return await bimSearch.getCollectionTable(collection);
}

// Save a collection in the database for this model
// throw "selection set already exist";
export async function saveCollection(collection, title, folder, descreption, color) {
    await bimSeachViewer.saveCollection(collection, title, folder, descreption, color);
}

// returns-
//      collection after change
// throw "selection set doesn't exist";
export async function addToCollection(elements, title, folder) {
    return await bimSeachViewer.addToCollection(elements, title, folder);
}

export async function removeFromCollection(elements, title, folder) {
    return await bimSeachViewer.removeFromCollection(elements, title, folder);
}

export async function removeFromTempCollection(elements, collection) {
    await bimSearch.removeElementsFromCollection(collection, elements);
    return collection;
}

// returns-
//      collection after change
export async function addToTempCollection(elements, collection) {
    await bimSearch.addElementsToCollection(collection, elements);
    return collection;
}

// returns-
//      [] of strings
export async function getCollectionsFolders() {
    var collections = await bimSeachViewer.getCollections();
    var collectionFolders = Object.keys(collections.collectionsByFolder);
    collectionFolders.sort();

    return collectionFolders;
}

// returns-
//      [] of collection
export async function getCollectionsForFolder(folder) {
    var collections = await bimSeachViewer.getCollections();
    return collections.collectionsByFolder[folder];
}

// returns-
//      QuickInfo
export async function getCollectionInfo(collection) {
    return await bimSearch.getCollectionInfo(collection);
}

// throws-
//      "can't find selection set"
//      "selection set already exist" - if new name already exist
export async function editCollection(oldTitle, oldFolder, newTitle, newFolder, newDescreption, newColor) {
    await bimSeachViewer.editCollection(oldTitle, oldFolder, newTitle, newFolder, newDescreption, newColor);
}


// returns-
//      collection after change
// throw "selection set doesn't exist";
export async function addSelectionToCollection(title, folder) {
    var selection = bimSeachViewer.viewer.getSelection();
    return await addToCollection(selection, title, folder);
}

export async function removeSelectionFromCollection(title, folder) {
    var selection = bimSeachViewer.viewer.getSelection();
    return await removeFromCollection(selection, title, folder);
}

export async function removeSelectionFromTempCollection(collection) {
    var selection = bimSeachViewer.viewer.getSelection();
    return await removeFromTempCollection(selection, collection);
}

export async function createTempCollectionFromSelection() {
    var selection = bimSeachViewer.viewer.getSelection();
    var properties = ["Type Name", "Description", "Length", "Area", "Volume"];
    var groups = [];
    return await createCollection(selection, properties, groups);
}

// throws-
//      "can't find selection set"
export async function deleteCollection(title, folder) {
    await bimSeachViewer.deleteCollection(title, folder);
}

// Color an array of collections
// input: Collection[]
export function colorCollections(collections) {
    bimSeachViewer.colorCollections(collections);
}

// Craete new collection folder
// returns collections folders // [] of strings (after the change)
// throw "folder already exist"
export async function addCollectionFolder(folderName) {
    await bimSeachViewer.addCollectionFolder(folderName);
    return await getCollectionsFolders();
}

// Delete a collection folder
// returns collection folders // [] of strings (after the change)
// throw "folder doesn't exist"
export async function deleteCollectionFolder(folderName) {
    await bimSeachViewer.deleteCollectionFolder(folderName);
    return await getCollectionsFolders();
}

// Rename a collection folder
// returns collection folders // [] of strings (after the change)
// throw "Folder already exist"
// throw "Folder doesn't exist"
export async function renameCollectionFolder(originalName, newName) {
    await bimSeachViewer.renameCollectionFolder(originalName, newName);
    return await getCollectionsFolders();
}


// return a dictonary object
// category name --> [] of QuickDataField
export async function getDetailedCollectionInfo(collection) {
    return await bimSearch.getDetailedCollectionInfo(collection);
}

// register 3 call-backs for the right click menu
export function registerRightClickMethods(saveAsCollection, copyToNewCollection, unassignSelection) {
    bimSeachViewer.registerCollectionMenuItems(saveAsCollection, copyToNewCollection, unassignSelection);
    
}

// unregister 3 call-backs for the right click menu
export function unregisterRightClickMethods() {
    bimSeachViewer.unregisterCollectionMenuItems();
}

export async function getSelection() {
  var selection = bimSeachViewer.viewer.getSelection();
  return selection;
}

export async function isolateSelection() {
    bimSeachViewer.isolateSelection();
}

export async function hideSelection() {
    bimSeachViewer.hideSelection();
}

export async function showAll() {
    bimSeachViewer.showAll();
}

// change ghosting mode, recieves true/false - true activate ghosting, false disables it
// when opening a model ghosting will always be on
export async function toggleGhosting(onOff) {
    bimSeachViewer.toggleGhosting(onOff);
}

// local instances
var bimSeachViewer; // autodesk viewer
var bimSearch; // Bim search filtered data iterator
